export default __webpack_public_path__ + "static/media/f_md-7.1a41ac8b.svg";